import API from "./API";
import axios from "axios";

export const Csv = {

    async getAll(){
        const url = API.url('/csv');
        return await axios.get(url);
    },

    async download(id, title){
        const url = API.url('/csv/' + id + '/data.csv');
        return await API.downloadFile(url, title);
    }

}